/* eslint func-style: "off" */

import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  HANDLE_LOGIN,
  HANDLE_OKTA_LOGIN,
  HANDLE_OKTA_LOGIN_FAIL,
  handleOktaLoginFailure,
  handleLoginSuccess,
  handleLoginFail
} from './Login.ducks';
import apiClient from 'helpers/apiClient';

const getLegacyLoginFormWithOkta = (state) => state.Login.legacyLoginFormWithOkta;

const handleLogin = function* (action) {
  try {
    let authLoginEndPoint = '/auth/login';
    const legacyLoginFormWithOkta = yield select(getLegacyLoginFormWithOkta);
    if(legacyLoginFormWithOkta){
      authLoginEndPoint = '/auth/loginOkta';
    }
    const payload = yield call(apiClient, authLoginEndPoint, {
      method: 'POST',
      body: JSON.stringify(action.payload)
    });

    yield put(handleLoginSuccess(payload));
  } catch (e) {
    yield put(handleLoginFail(e.message));
  }
};

const handleOktaLogin = function* (action) {
  const { payload } = action;
  if (payload.status === 'SUCCESS') {
    const username = payload.tokens.idToken.claims.zignalIdTokenClaim.profile.userName;
    const refreshToken = payload.tokens.refreshToken.refreshToken;
    try {
      yield call(apiClient, '/auth/okta_session', {
        method: 'POST',
        headers:{
          Authorization: `Bearer ${payload.tokens.accessToken.accessToken}`,
        },
        body: JSON.stringify({
          username,
          refreshToken
        })
      });
      yield put(handleLoginSuccess(true));
    } catch (e) {
      yield put(handleOktaLoginFailure(e.body ? e.body.error :  e.message));
    }
  }
};

const loginSaga = function* () {
  yield takeLatest(HANDLE_LOGIN, handleLogin);
};

const loginOktaSaga = function* () {
  yield takeLatest(HANDLE_OKTA_LOGIN, handleOktaLogin);
};

const loginOktaFailSaga = function* () {
  yield takeLatest(HANDLE_OKTA_LOGIN_FAIL, handleOktaLoginFail);
};

const sagas = function* () {
  yield all([
    fork(loginSaga),
    fork(loginOktaSaga)
  ]);
};

export default sagas;
export {
  handleLogin,
  handleOktaLogin,
  loginSaga,
  loginOktaSaga,
  loginOktaFailSaga
};
